import type { ConsumerViewSvgProps } from "./ConsumerViewSvg";
import type { MemoViewSvgProps } from "./MemoViewSvg";

type MeasureText = (text: string, font: string) => { width: number };

/** Resolves the classic symbol geometry without selection or other editor state. */
export function classicConsumerLayout(input: {
  size: number; pixelsPerMm: number; floorPlan: boolean; roomScale: number;
  consumer: boolean; tag?: string; image?: string; background: string; color: string; quantity?: number;
}, measure: MeasureText): ConsumerViewSvgProps {
  const width = input.size * input.pixelsPerMm * (input.floorPlan ? 0.5 / input.roomScale : 1);
  let fontSize = Math.round(width * 0.5 * 10) / 10;
  if (input.tag) {
    const measured = measure(input.tag, fontSize + "px").width;
    if (measured > width - 10) fontSize = Math.round(fontSize * Math.max(1, width - 10) / measured * 10) / 10;
  }
  let image = input.image;
  if (image && input.color === "#fff" && image.toLowerCase().endsWith(".png")) {
    image = image.slice(0, -4) + "-white" + image.slice(-4);
  }
  return { width, height: input.tag && image ? width * 1.5 : width, radius: input.consumer ? width / 2 : 2,
    background: input.background, color: input.color, tag: input.tag, fontSize, image,
    imageSize: Math.max(0, input.tag ? width * 0.5 : width - 10), imageTop: width / 6,
    tagBottom: input.consumer ? 5 : 0, quantity: input.quantity };
}

/** Uses the same line metrics and padding for an editor memo and its exported SVG. */
export function classicMemoLayout(text: string, fontSize: number, scale: number, roomTag: boolean, measure: MeasureText): MemoViewSvgProps {
  fontSize *= 0.7;
  const lines = text.split("\n");
  let width = 0;
  for (const line of lines) width = Math.max(width, measure(line, fontSize + "px").width);
  const padding = fontSize * (roomTag ? 0.4 : 0.7);
  const lineHeight = fontSize * 1.2;
  const paddingY = fontSize * (roomTag ? 0.15 : 0.3);
  return { lines, width: width + padding * 2 + 2, height: lines.length * lineHeight + paddingY * 2,
    fontSize, lineHeight, padding, paddingY, radius: (roomTag ? 5 : 10) * scale, borderWidth: 0.6 * scale,
    textAlign: roomTag ? "center" : undefined,
    borderColor: "#b8bec4" };
}
